import { IUser } from '@sdk/contracts';
import { Flex, Form } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Wrapper } from './AttachStudentFilesForManager.styles';

import { UploadDragAndDrop } from '@/components/UploadDragAndDrop';
import { useUserInfoByUser } from '@/store/users/user-info/useUserInfo';

type AttachStudentFilesForManagerProps = {
  profile?: IUser;
};

export const AttachStudentFilesForManager: React.FC<AttachStudentFilesForManagerProps> = ({
  profile
}) => {
  const { t } = useTranslation('StudentProfileConfigurationTranslations');
  const form = Form.useFormInstance();
  const { userInfo } = useUserInfoByUser(profile?._id || '');

  useEffect(() => {
    if (userInfo && form) {
      form.setFieldsValue({
        identityDocFile: userInfo.identityDocFile,
        degreeFile: userInfo.degreeFile,
        socialSecurityFile: userInfo.socialSecurityFile,
        photo: userInfo.photo,
        subjectsToValidate: userInfo.subjectsToValidate,
        companyTrainingExemptionFile: userInfo.companyTrainingExemptionFile,
        notesEquivalenceFile: userInfo.notesEquivalenceFile
      });
    }
  }, [userInfo, form]);

  return (
    <Wrapper>
      <Flex vertical gap={24}>
        <Form.Item label={t('DNI_FILE')} name={['identityDocFile']}>
          <UploadDragAndDrop
            modalConfirmOnDelete
            acceptedTypes={['.pdf']}
            maxSizeInMB={10}
            returnFileObject={true}
          />
        </Form.Item>

        <Form.Item label={t('DEGREE_FILE')} name={['degreeFile']}>
          <UploadDragAndDrop
            modalConfirmOnDelete
            acceptedTypes={['.pdf']}
            maxSizeInMB={10}
            returnFileObject={true}
          />
        </Form.Item>

        <Form.Item label={t('SOCIAL_SECURITY_FILE')} name={['socialSecurityFile']}>
          <UploadDragAndDrop
            modalConfirmOnDelete
            acceptedTypes={['.pdf']}
            maxSizeInMB={10}
            returnFileObject={true}
          />
        </Form.Item>

        <Form.Item label={t('PHOTO')} name={['photo']}>
          <UploadDragAndDrop
            modalConfirmOnDelete
            acceptedTypes={['.gif', '.jpg']}
            maxSizeInMB={15}
            returnFileObject={true}
          />
        </Form.Item>

        <Form.Item label={t('SUBJECTS_TO_VALIDATE')} name={['subjectsToValidate']}>
          <UploadDragAndDrop
            modalConfirmOnDelete
            acceptedTypes={['.pdf']}
            maxSizeInMB={10}
            returnFileObject={true}
          />
        </Form.Item>

        <Form.Item
          label={t('COMPANY_TRAINING_EXEMPTION_FILE')}
          name={['companyTrainingExemptionFile']}>
          <UploadDragAndDrop
            modalConfirmOnDelete
            acceptedTypes={['.pdf']}
            maxSizeInMB={10}
            returnFileObject={true}
          />
        </Form.Item>

        <Form.Item label={t('NOTES_EQUIVALENCE_FILE')} name={['notesEquivalenceFile']}>
          <UploadDragAndDrop
            modalConfirmOnDelete
            acceptedTypes={['.pdf']}
            maxSizeInMB={10}
            returnFileObject={true}
          />
        </Form.Item>
      </Flex>
    </Wrapper>
  );
};
